import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-bubble-selector',
    templateUrl: './bubble-selector.component.html',
    styleUrls: ['./bubble-selector.component.scss'],
    standalone: false
})
export class BubbleSelectorComponent {
    @Input() extractLabelFn: (any) => string = (v) => v;
    @Input() options: any[];
    @Input() dashboardSelector;
    @Output() onSelectionChange = new EventEmitter<any[]>();
    @Output() onClear = new EventEmitter<void>();

    selectedElements: any[] = [];
    selectedElementLookup = new Set<any>();

    toggleSelected(elem: any) {
        if (this.selectedElementLookup.has(elem)) {
            const index = this.selectedElements.indexOf(elem);
            this.selectedElements.splice(index, 1);
            this.selectedElementLookup.delete(elem);
        } else {
            this.selectedElements.push(elem);
            this.selectedElementLookup.add(elem);
        }

        this.onSelectionChange.emit([...this.selectedElements]);
    }

    isSelected(elem: any) {
        return this.selectedElementLookup.has(elem);
    }

    clearSelection() {
        this.selectedElements = [];
        this.selectedElementLookup = new Set<any>();
        this.onClear.emit();
    }
}
